import React, { useState, useRef, useEffect } from "react";
import DataTable from "react-data-table-component";
import { DefaultImageBaseurl, endPoints, PlayerSiteUrl } from "../../../constant/Environment";
import { getSessonId } from "../../../Utility/axiosInstances";
import {
  addData,
  deleteData,
  getAllData,
  getAllFilterData,
} from "../../../Utility/API";
import { Modal, Form, Button, Dropdown, Tab } from "react-bootstrap";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Actions } from "../../../redux/Actions/Actions";
import Toaster from "../../../components/Toast";
import Loader from "../../../components/Loader";
import PageHeader from "../../../components/PageHeader";
import ManualDepositConfigModal from "./ManualDepositConfigModal";
import { ErrorToast, SuccesToast } from "../../../components/Toast/message";
import { AiTwotoneEyeInvisible, AiFillEyeInvisible } from "react-icons/ai";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import moment from "moment-timezone";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";

import Switch from "@mui/material/Switch";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import InfoIcon from "@mui/icons-material/Info";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import DeleteModel from "../../../components/DeleteModel";
import { Filter } from "@mui/icons-material";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import Autocomplete from "@mui/material/Autocomplete";
import CircularProgress from "@mui/material/CircularProgress";

import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Chip from "@mui/material/Chip";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
  // .modal is z-index 1500 in skin.css; keep the menu above it
  sx: { zIndex: 1600 },
};

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

// Languages the platform serves. English is the base text on the main form;
// the rest are stored as translation rows and fall back to English when blank.
const LANGUAGES = [
  { code: "en", name: "English", flag: "🇺🇸" },
  { code: "es", name: "Español", flag: "🇪🇸" },
  { code: "pt", name: "Português", flag: "🇧🇷" },
  { code: "it", name: "Italiano", flag: "🇮🇹" },
];
const LANGS = LANGUAGES.filter((l) => l.code !== "en");

const emptyTranslations = () =>
  LANGS.reduce((acc, l) => {
    acc[l.code] = { package_name: "" };
    return acc;
  }, {});

const CoinPackage = () => {
  const [editData, setEditData] = useState({});
  const [createData, setCreateData] = useState(false);
  const [rowDataToDelete, setRowDataToDelete] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const [packageName, setPackageName] = useState("");
  const [translations, setTranslations] = useState(emptyTranslations());
  const [showTranslations, setShowTranslations] = useState(false);

  const setTranslationField = (lang, key, value) =>
    setTranslations((prev) => ({
      ...prev,
      [lang]: { ...prev[lang], [key]: value },
    }));

  // Load the stored per-language rows into the edit form.
  const fetchTranslations = async (id) => {
    setTranslations(emptyTranslations());
    try {
      const response = await getAllData(`${endPoints.api.GET_PACKAGE_TRANSLATIONS}${id}`);
      if (response?.status === "success") {
        const next = emptyTranslations();
        (response.data || []).forEach((t) => {
          const code = String(t.language_code || "").toLowerCase();
          if (next[code]) {
            next[code] = { package_name: t.package_name || "" };
          }
        });
        setTranslations(next);
      }
    } catch (e) {
      console.error("translations fetch failed", e);
    }
  };
  const [goldCoin, setGoldCoin] = useState("");
  const [sagaCoin, setSagaCoin] = useState("");
  const [purchasePrice, setPurchasePrice] = useState("");
  const [maxCliam, setMaxCliam] = useState(0);
  const [menuSort, setMenuSort] = useState("");

  const [dailyBounsAmount, setDailyBounsAmount] = useState("");
  const [bounsDays, setBounsDays] = useState("");
  const [bonusCoin, setBonusCoin] = useState("");

  const [creative, setCreative] = useState("");
  const [showcreative, setShowCreative] = useState("");

  const [day, setDay] = useState("");
  const [multiplier, setMultiplier] = useState("");
  const [limit, setLimit] = useState("");

  const [pending, setPending] = useState(true);
  const [show, setShow] = useState(false);
  const [manualDepositShow, setManualDepositShow] = useState(false);
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleClose = () => setShow(false);

  // package amounts (all currencies) dialog
  const [showAmounts, setShowAmounts] = useState(false);
  const [amountsData, setAmountsData] = useState(null);

  const handleViewAmounts = async (row) => {
    setShowAmounts(true);
    setAmountsData(null);
    setIsLoading(true);
    try {
      const response = await getAllData(
        `${endPoints.api.GET_PACKAGE_AMOUNTS}${row.id}/amounts`
      );
      // backend wraps responses in { status, data }; tolerate a raw shape too
      const body = response?.data ?? response;
      setAmountsData(body);
    } catch (error) {
      console.error(error);
      ErrorToast("Unable to load package amounts");
    } finally {
      setIsLoading(false);
    }
  };

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const [totalPackage, setTotalPackage] = useState([]);
  const [excludePackage, setExcludePackage] = useState([]);
  const [sortOrder, setSortOrder] = useState("");

  const [playerList, setPlayerList] = useState([]);
  const [excludePlayerTypes, setExcludePlayerTypes] = useState([]);

  // console.log("excludePackage", editData);

  const handleChange = (event) => {
    const value = event.target.value;
    setExcludePackage(typeof value === "string" ? value.split(",") : value);
  };

  const [checkboxes, setCheckboxes] = useState({
    isCheckedActive: false,
    isFeature: false,
    isPopular: false,
    isSpecial: false,
    dailyBounsEnable: false,
    freeSpin: false,
    isBoost: false,
    dailyStreak: false,
    emailPackage: false,
  });

  const [freeSpinValue, setFreeSpinValue] = useState("");
  const [freeSpinGameName, setFreeSpinGameName] = useState("");
  const [freeSpinGame, setFreeSpinGame] = useState(null);
  const[freespingameid, setFreeSpingameid] = useState("");
  const [freeSpinFromDate, setFreeSpinFromDate] = useState("");
  const [freeSpinToDate, setFreeSpinToDate] = useState("");
  const [boostValue, setBoostValue] = useState("");
  const [featureName, setFeatureName] = useState("");
  const [gameSearchTerm, setGameSearchTerm] = useState("");
  const [filteredGames, setFilteredGames] = useState([]);
  const [loadingGames, setLoadingGames] = useState(false);
  const[spincount, setSpincount] = useState("");
  const [copyUrlVisible, setCopyUrlVisible] = useState(false);
  const [packageUrl, setPackageUrl] = useState("");

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    setCheckboxes((prevCheckboxes) => ({
      ...prevCheckboxes,
      [name]: checked,
    }));
    if (name == "isBoost" && !checked) {
      setBoostValue("");
    }
    if (name === "emailPackage") {
      if (checked && editData?.id) {
        const url = fetchEmailurl(editData);
        setPackageUrl(url);
        setCopyUrlVisible(true);
      } else {
        setCopyUrlVisible(false);
        setPackageUrl("");
      }
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setCreative(file);
      setShowCreative(imageUrl);
      UploadImage(file);
    }
  };

  const handleCopyUrl = () => {
    if (packageUrl) {
      navigator.clipboard.writeText(packageUrl)
        .then(() => {
          SuccesToast("URL copied to clipboard!");
        })
        .catch((error) => {
          console.error("Failed to copy:", error);
          ErrorToast("Failed to copy URL");
        });
    }
  };

  // private Boolean freeSpin;
	// private Integer spinCount;
	// private Double spinValue;
	// private String featureName;
	// private Timestamp spinStartDate;
	// private Timestamp spinEndDate;
	// private String gameId;

  const UploadImage = (files) => {
    var formdata = new FormData();
    formdata.append("file", files);
    var requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow",
      headers: getSessonId() ? { SessonId: getSessonId() } : {},
    };
    setIsLoading(true);
    let imgUrl = `${endPoints.apiBaseUrl}${endPoints.api.UPLOAD_BANNER}`;
    fetch(imgUrl, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setCreative(result.data);
        setIsLoading(false);
      })
      .catch((error) => console.log("error", error));
  };

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    fetchCoinPackage();
    getPlayerTypes();
  }, []);

  const getPlayerTypes = () => {
    let url = `${endPoints.api.playertypes}`;
    getAllData(url)
      .then((response) => {
        if (response.status === "success") {
          setPlayerList(response.data);
        }
      })
      .catch((err) => console.error("Error fetching player types:", err));
  };

  const handlePlayerTypeChange = (playerId) => {
    setExcludePlayerTypes((prev) =>
      prev.includes(playerId)
        ? prev.filter((id) => id !== playerId)
        : [...prev, playerId]
    );
  };

  const searchGames = async (searchTerm) => {
    if (!searchTerm || searchTerm.length < 2) {
      setFilteredGames([]);
      return;
    }
    
    setLoadingGames(true);
    try {
      let url_gamesearch = `${endPoints.api.SEARCH_FREESPIN_GAMES}/${encodeURIComponent(searchTerm)}`;
      const response = await getAllData(url_gamesearch);
      
      if (response?.status === "success") {
        setFilteredGames(response?.data || []);
      } else {
        console.error("Failed to search games:", response);
        setFilteredGames([]);
      }
    } catch (error) {
      console.error("Error searching games:", error);
      setFilteredGames([]);
    } finally {
      setLoadingGames(false);
    }
  };

  useEffect(() => {
    const delayedGameSearch = setTimeout(() => {
      if (gameSearchTerm) {
        searchGames(gameSearchTerm);
      } else {
        setFilteredGames([]);
      }
    }, 500);

    return () => clearTimeout(delayedGameSearch);
  }, [gameSearchTerm]);

  const fetchCoinPackage = async () => {
    let url = `${endPoints.api.GET_PACKAGE}`;
    setIsLoading(true);
    await getAllData(url)
      .then((response) => {
        setIsLoading(false);
        if (response.status === "success") {
          setRows(response.data);
          setTotalPackage(response.data);
          setPending(false);
        } else {
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };

  const handleOk = () => {
    if(checkboxes.freeSpin){
     if((spincount == "" || freeSpinValue == "" || freespingameid == "")){
      ErrorToast("Please select all free spin values to enable free spin");
      return;
    }
    }
    // debugger
    if (
      packageName &&
      // goldCoin &&
      // sagaCoin &&
      purchasePrice &&
      maxCliam &&
      // menuSort &&
      creative
    ) {
      if (checkboxes.isBoost && !boostValue) {
        ErrorToast("Please add boost value when Coin Boost is enabled");
        return;
      }
      let url = editData?.id
        ? `${endPoints.api.UPDATE_PACKAGE}`
        : `${endPoints.api.ADD_PACKAGE}`;

      let payload = {
        package_name: packageName,
        // Only languages with a name filled in are sent; the API upserts them.
        translations: LANGS.map((l) => ({
          language_code: l.code,
          package_name: translations[l.code]?.package_name || "",
        })).filter((t) => t.package_name),
        creative: creative,
        goldcoins:0, //goldCoin,
        sagacoins:0, //sagaCoin,
        purchase_price: purchasePrice,
        max_claim_perday: maxCliam,
        menu_sort_order: menuSort,
        isactive: checkboxes.isCheckedActive ? 1 : 0,
        max_claim: limit,
        days: day,
        isFeature: checkboxes.isFeature ? 1 : 0,
        isPopular: checkboxes.isPopular ? 1 : 0,
        exclude_package: excludePackage,
        exclude_player: excludePlayerTypes,
        isSpecial: checkboxes.isSpecial ? 1 : 0,
        daily_bouns_enable: checkboxes.dailyBounsEnable ? 1 : 0,
        isBoost: checkboxes.isBoost ? 1 : 0,
        daily_bouns_amount: dailyBounsAmount,
        bouns_days: bounsDays,
        multplier: multiplier,
        freeSpin: checkboxes.freeSpin ? true : false,
        spinCount: spincount,
        spinValue: freeSpinValue, 
        featureName: featureName,
        spinStartDate: freeSpinFromDate,
        spinEndDate: freeSpinToDate,
        gameName: gameSearchTerm || "",
        gameId: freespingameid || "",
        sortOrder: sortOrder || 0,
        boostValue: checkboxes.isBoost ? boostValue : "",
        dailyStreak: checkboxes.dailyStreak ? 1 : 0,
        emailPackage: checkboxes.emailPackage ? 1 : 0,
        bonus_amount: bonusCoin,
      };
      // console.log(payload);
      if (editData?.id) {
        payload.id = editData.id;
      }
      setIsLoading(true);
      addData(url, payload)
        .then((response) => {
          setIsLoading(false);
          if (response.data.status === "success") {
            SuccesToast(response?.data?.message);
            fetchCoinPackage();

            handleClose();
          }
        })
        .catch((error) => {
          setIsLoading(false);
          console.error(error);
          ErrorToast(error);
        });
    } else {
      ErrorToast("all fields are required");
    }
  };

  useEffect(() => {
    if (editData) {
      let imageFullPath =
        editData.creative !== undefined
          ? `${endPoints.apiBaseUrl}${editData.creative}`
          : "";
      setPackageName(editData.package_name || "");
      if (editData.id) {
        fetchTranslations(editData.id);
      } else {
        setTranslations(emptyTranslations());
      }
      setCreative(editData.creative || "");
      setShowCreative(imageFullPath || "");
      setGoldCoin(editData.goldcoins || "");
      setSagaCoin(editData.sagacoins || "");
      setPurchasePrice(editData.purchase_price || "");
      setMaxCliam(editData.max_claim_perday || "");
      setMenuSort(editData.menu_sort_order || "");
      setSortOrder(editData.sortOrder || "");
      setCheckboxes((prevCheckboxes) => ({
        ...prevCheckboxes,
        isCheckedActive: editData.isactive || false,
        isFeature: editData.isFeature || false,
        isPopular: editData.isPopular || false,
        isSpecial: editData?.isSpecial || false,
        dailyBounsEnable: editData?.daily_bouns_enable || false,
        freeSpin: editData?.freeSpin || false,
        isBoost: editData?.isBoost  ? true : false,
        dailyStreak: editData?.dailyStreak ? true : false,
        emailPackage: editData?.emailPackage ? true : false,
      }));
      // daily_bouns_enable: checkboxes.dailyBounsEnable ? 1 : 0,
      // daily_bouns_amount: dailyBounsAmount,
      // bouns_days: bounsDays,
      setBounsDays(editData?.bouns_days || "");
      setDailyBounsAmount(editData?.daily_bouns_amount || "");
      setBonusCoin(editData?.bonus_amount || "");

      setLimit(editData.max_claim || "");
      setDay(editData.days || "");
      setMultiplier(editData?.multplier || "");
      setExcludePackage(editData?.exclude_package || []);
      setExcludePlayerTypes(editData?.exclude_player || []);
      setFreeSpinValue(editData?.spinValue || "");
      setSpincount(editData?.spinCount || "");
      setFeatureName(editData?.featureName || "");
      setFreeSpinFromDate(editData?.spinStartDate ? moment(editData.spinStartDate).format('YYYY-MM-DD') : "");
      setFreeSpinToDate(editData?.spinEndDate ? moment(editData.spinEndDate).format('YYYY-MM-DD') : "");
      setGameSearchTerm(editData?.gameName || "");
      setFreeSpingameid(editData?.gameId || "");
      setBoostValue(editData?.boostValue || "");
      // Fetch game details to populate freeSpinGame with freeCounts and betSize
      if (editData?.gameId) {
        Gamedetail(editData.gameId).then(gameData => {
          if (gameData) {
            setFreeSpinGame(gameData);
          }
        });
      }
      // Set copy URL if email package is enabled and ID exists
      if (editData?.emailPackage && editData?.id) {
        const url = fetchEmailurl(editData);
        setPackageUrl(url);
        setCopyUrlVisible(true);
      } else {
        setCopyUrlVisible(false);
        setPackageUrl("");
      }
    }
  }, [editData]);

  const Gamedetail = async (gameid) => {
    let url = `${endPoints.api.GAME_DETAILS}/${gameid}`;
    try {
      const response = await getAllData(url);
      if (response?.status === "success") {
        return response?.data;
      }
    } catch (error) {
      console.error("Error fetching game details:", error);
      return null;
    }
  };  

  const handleDelete = (row) => {
    setRowDataToDelete(row);
    setShowDeleteModal(true);
  };

  const deleteCoinPackage = () => {
    const id = rowDataToDelete.id;

    let url = `${endPoints.api.DELETE_PACKAGE}${id}`;
    setIsLoading(false);
    deleteData(url)
      .then((response) => {
        console.log("update_Res", response);
        setIsLoading(false);
        if (response.status == 200) {
          setShowDeleteModal(false);
          fetchCoinPackage();
          SuccesToast("Deleted Successfully");
        } else {
        }
      })
      .catch((error) => {
        console.error(error);
        setIsLoading(false);
      });
  };

  const handleSwitchChange = (row, param, value) => {
    const updatedRow = { ...row, [param]: value === 0 ? 1 : 0 };
    updateCoinPackage(updatedRow);
  };

  const updateCoinPackage = (payload) => {
    const id = payload.id;
    let url = `${endPoints.api.UPDATE_PACKAGE}`;
    setIsLoading(true);
    addData(url, payload)
      .then((response) => {
        setIsLoading(false);
        if (response.data.status === "success") {
          SuccesToast(response?.data?.message);
          fetchCoinPackage();

          handleClose();
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
        ErrorToast(error);
      });
  };

  // CoinPackage Filter
  const [filteredRows, setFilteredRows] = useState(rows);
  const [filterValue, setFilterValue] = useState("");

  const handleFilterChange = (event) => {
    const newFilterValue = event.target.value.toLowerCase();
    setFilterValue(newFilterValue);

    if (newFilterValue === "") {
      setFilteredRows(rows);
    } else {
      const filteredData = rows.filter((item) =>
        item.package_name.toLowerCase().includes(newFilterValue)
      );
      setFilteredRows(filteredData);
    }
  };

  const rowsToDisplay = filterValue.length > 0 ? filteredRows : rows;

  // Player-facing buy-coins link for the "Email Package" flag. The host comes
  // from PlayerSiteUrl (REACT_APP_STAGE) so stage builds link to stage-coin and prod
  // builds link to coin. Returns "" when the row has no packageId yet.
  const fetchEmailurl = (pkg) =>
    pkg?.packageId
      ? `${PlayerSiteUrl}/buy-coins?packageId=${pkg.packageId}&segment=N1`
      : "";

    // betsize = freespinvalue
    // sincount = freespincount

  return (
    <>
      <div className="main">
        <Toaster></Toaster>
        <DeleteModel
          showModal={showDeleteModal}
          onClose={() => setShowDeleteModal(false)}
          onDelete={deleteCoinPackage}
        />

        {/* Package value in all currencies */}
        <Modal
          show={showAmounts}
          onHide={() => setShowAmounts(false)}
          size="lg"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              Package Value by Currency
              {amountsData?.package_name ? ` — ${amountsData.package_name}` : ""}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {amountsData && (
              <div className="row mb-3">
                <div className="col-md-6">
                  <strong>Package Amount (USD):</strong>{" "}
                  {amountsData.package_amount}
                </div>
                <div className="col-md-6">
                  <strong>Bonus Amount (USD):</strong>{" "}
                  {amountsData.bonus_amount}
                </div>
              </div>
            )}
            <TableContainer component={Paper}>
              <Table size="small" stickyHeader aria-label="package amounts table">
                <TableHead>
                  <TableRow>
                    <TableCell align="center">Currency</TableCell>
                    <TableCell align="center">Country</TableCell>
                    <TableCell align="center">Package Amount</TableCell>
                    <TableCell align="center">Bonus Amount</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(amountsData?.amounts || []).map((item) => (
                    <TableRow key={item.currency}>
                      <TableCell align="center">{item.currency}</TableCell>
                      <TableCell align="center">{item.country}</TableCell>
                      <TableCell align="center">{item.package_amount}</TableCell>
                      <TableCell align="center">{item.bonus_amount}</TableCell>
                    </TableRow>
                  ))}

                  {amountsData && (amountsData.amounts || []).length === 0 && (
                    <TableRow>
                      <TableCell colSpan={4} align="center">
                        No currency data found
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={() => setShowAmounts(false)}
              style={{ background: "#04631e", borderColor: "#04631e" }}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        {isLoading && <Loader spinner={true} visible={isLoading} />}
        <div id="Sportbook" style={{ padding: "0px" }}>
          <div className="container-fluid bg-color-sportbook custom-card4">
            <div className="inner-space1">
              <PageHeader title="Coin Package" crumb="Casino / Coin Package" />

              <div style={{ marginTop: "10px" }}>
                <div className="table_search">
                  <TextField
                    style={{ marginBottom: "10px", width: "25%" }}
                    placeholder="Enter package name to search..."
                    type="text"
                    onChange={handleFilterChange}
                    value={filterValue}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <TableContainer component={Paper}>
                      <Table
                        className="c_table"
                        size="small"
                        // aria-label="a dense table"
                        stickyHeader
                        // aria-label="sticky table"
                        sx={{ minWidth: 500 }}
                        aria-label="custom pagination table"
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell align="center">Pack ID</TableCell>
                            <TableCell align="center"> Name</TableCell>
                            {/* <TableCell align="center">GC </TableCell>
                            <TableCell align="center">SC </TableCell> */}
                            <TableCell align="center"> Price</TableCell>
                            <TableCell align="center">Bonus</TableCell>
                            <TableCell align="center">Total Buy</TableCell>
                            <TableCell align="center">Sort</TableCell>
                            <TableCell align="center">Unique</TableCell>
                            <TableCell align="center">Limit</TableCell>
                            <TableCell align="center">Day</TableCell>
                            <TableCell align="center">Play</TableCell>
                            <TableCell align="center">Creative</TableCell>
                            {/* <TableCell align="center">
                              Menu Sort Order
                            </TableCell> */}
                            <TableCell align="center">Active</TableCell>
                            <TableCell align="center">Special</TableCell>

                            <TableCell align="center">Popular</TableCell>
                            <TableCell align="center">Options</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rowsToDisplay
                            .slice(
                              page * rowsPerPage,
                              page * rowsPerPage + rowsPerPage
                            )
                            .map((row) => (
                              <TableRow
                                key={row.id}
                                sx={{
                                  "&:last-child td, &:last-child th": {
                                    border: 0,
                                  },
                                }}
                              >
                                <TableCell align="center">{row.id}</TableCell>
                                <TableCell align="center">
                                  {row.package_name}
                                </TableCell>
                                {/* <TableCell align="center">
                                  {row.goldcoins}
                                </TableCell>
                                <TableCell align="center">
                                  {row.sagacoins}
                                </TableCell> */}
                                <TableCell align="center">
                                  {" "}
                                  $ {row.purchase_price}
                                </TableCell>
                                <TableCell align="center">
                                  {row.bonus_amount || 0}
                                </TableCell>
                                <TableCell align="center">
                                {row.totalBuy}
                                  </TableCell>
                                <TableCell align="center">
                                  {row?.sortOrder}
                                  </TableCell>    
                                  <TableCell align="center">
                                  {row.totalCustomerBuy}
                                  </TableCell>
                                <TableCell align="center">
                                  {row.max_claim}
                                </TableCell>
                                <TableCell align="center">{row.days}</TableCell>
                                <TableCell align="center">{`${row?.multplier}x`}</TableCell>
                                {/* <TableCell align="center">{row?.featureName}</TableCell>
                                <TableCell align="center">{row?.freeSpin}</TableCell>
                                <TableCell align="center">{row?.spinCount}</TableCell>
                                <TableCell align="center">{row?.spinStartDate ? moment(row?.spinStartDate).format('YYYY-MM-DD') : ''}</TableCell>
                                <TableCell align="center">{row?.spinEndDate ? moment(row?.spinEndDate).format('YYYY-MM-DD') : ''}</TableCell>
                                <TableCell align="center">{row?.gameId}</TableCell> */}
                                <TableCell align="center">
                                  <img
                                    src={`${DefaultImageBaseurl}${row.creative}`}
                                    style={{ height: "50px" }}
                                  />
                                </TableCell>
                                {/* <TableCell align="center">
                                  {row.menu_sort_order}
                                </TableCell> */}

                                <TableCell align="center">
                                  <Switch
                                    checked={row.isactive !== 0}
                                    onChange={() =>
                                      handleSwitchChange(
                                        row,
                                        "isactive",
                                        row.isactive
                                      )
                                    }
                                  />
                                </TableCell>

                                <TableCell align="center">
                                  <Switch
                                    checked={row.isSpecial !== 0}
                                    onChange={() =>
                                      handleSwitchChange(
                                        row,
                                        "isSpecial",
                                        row.isSpecial
                                      )
                                    }
                                  />
                                </TableCell>
                                <TableCell align="center">
                                  <Switch
                                    checked={row.isPopular !== 0}
                                    onChange={() =>
                                      handleSwitchChange(
                                        row,
                                        "isPopular",
                                        row.isPopular
                                      )
                                    }
                                  />
                                </TableCell>

                                <TableCell align="center">
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      gap: "10px",
                                      flexWrap: "nowrap",
                                    }}
                                  >
                                    <InfoIcon
                                      style={{ cursor: "pointer" }}
                                      onClick={() => handleViewAmounts(row)}
                                    />

                                    <EditIcon
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        setShow(true);
                                        setCreateData(true);
                                        setEditData(row);
                                      }}
                                    />

                                    <DeleteIcon
                                      style={{ cursor: "pointer" }}
                                      onClick={() => handleDelete(row)}
                                    />
                                  </div>
                                </TableCell>
                              </TableRow>
                            ))}

                          {emptyRows > 0 && (
                            <TableRow style={{ height: 53 * emptyRows }}>
                              <TableCell colSpan={6} />
                            </TableRow>
                          )}
                        </TableBody>
                        <TableFooter>
                          <TableRow>
                            <TablePagination
                              rowsPerPageOptions={[
                                5,
                                10,
                                25,
                                { label: "All", value: -1 },
                              ]}
                              colSpan={12}
                              count={rowsToDisplay.length}
                              rowsPerPage={rowsPerPage}
                              page={page}
                              SelectProps={{
                                inputProps: {
                                  "aria-label": "rows per page",
                                },
                                native: true,
                              }}
                              onPageChange={handleChangePage}
                              onRowsPerPageChange={handleChangeRowsPerPage}
                              ActionsComponent={TablePaginationActions}
                            />
                          </TableRow>
                        </TableFooter>
                      </Table>
                    </TableContainer>
                  </div>
                  <>
                    <Modal show={show} onHide={handleClose} size="lg">
                      <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">
                          Manage Coin Package
                        </Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <div className="row">
                          <div className="col-md-6">
                            <Form.Group
                              className="mb-3"
                              controlId="providerName"
                            >
                              <Form.Label>Package Name </Form.Label>
                              <div style={{ display: "flex", gap: "8px" }}>
                                <Form.Control
                                  type="text"
                                  placeholder="Package Name"
                                  value={packageName}
                                  onChange={(event) => {
                                    setPackageName(event.target.value);
                                  }}
                                />
                                <Button
                                  variant="primary"
                                  style={{ background: "#0D3862", borderRadius: "8px", whiteSpace: "nowrap" }}
                                  onClick={() => setShowTranslations(true)}
                                >
                                  Translations
                                </Button>
                              </div>
                            </Form.Group>
                          </div>
                          <div className="col-md-6">
                            <Form.Group className="mb-3" controlId="game">
                              <Form.Label>Upload Creative </Form.Label>
                              <Form.Control
                                type="file"
                                placeholder="Upload Creative"
                                onChange={handleFileChange}
                              />
                            </Form.Group>
                          </div>
                          {/* <div className="col-md-4">
                            <Form.Group
                              className="mb-3"
                              controlId="providerName"
                            >
                              <Form.Label>Gold Coin </Form.Label>
                              <Form.Control
                                type="number"
                                placeholder="Gold Coin"
                                value={goldCoin}
                                onChange={(event) => {
                                  setGoldCoin(event.target.value);
                                }}
                              />
                            </Form.Group>
                          </div> */}

                          <div className="col-md-4">
                             <Form.Group
                              className="mb-3"
                              controlId="providerName"
                            >
                              <Form.Label>Sort Order </Form.Label>
                              <Form.Control
                                type="number"
                                placeholder="Sort Order"
                                value={sortOrder}
                                onChange={(event) => {
                                  setSortOrder(event.target.value);
                                }}
                              />
                            </Form.Group>
                          </div>

                          <div className="col-md-4">
                            {showcreative && (
                              <div>
                                <img
                                  src={showcreative}
                                  alt="Selected"
                                  style={{ maxWidth: "100px" }}
                                />
                              </div>
                            )}
                          </div>

                          
                          <div className="col-md-6">
                            <Form.Group
                              className="mb-3"
                              controlId="bonusCoin"
                            >
                              <Form.Label>Bonus Coin</Form.Label>
                              <Form.Control
                                type="number"
                                placeholder="Enter bonus coin value"
                                value={bonusCoin}
                                onChange={(event) => {
                                  setBonusCoin(event.target.value);
                                }}
                              />
                            </Form.Group>
                          </div>

                          {/* <div className="col-md-6">
                            <Form.Group
                              className="mb-3"
                              controlId="providerName"
                            >
                              <Form.Label>Saga Coin</Form.Label>
                              <Form.Control
                                type="number"
                                placeholder="Saga Coin"
                                value={sagaCoin}
                                onChange={(event) => {
                                  setSagaCoin(event.target.value);
                                }}
                              />
                            </Form.Group>
                          </div> */}
                          <div className="col-md-6">
                            <Form.Group
                              className="mb-3"
                              controlId="providerName"
                            >
                              <Form.Label>Purchase Price</Form.Label>
                              <Form.Control
                                type="number"
                                step="0.01"
                                min="0"
                                placeholder="Purchase Price"
                                value={purchasePrice}
                                onChange={(event) => {
                                  setPurchasePrice(event.target.value);
                                }}
                              />
                            </Form.Group>
                          </div>
                          <div className="col-md-6">
                            <Form.Group
                              className="mb-3"
                              controlId="providerName"
                            >
                              <Form.Label>Daily Transfer Coin</Form.Label>
                              <Form.Control
                                type="number"
                                placeholder="Daily Transfer Coiny"
                                value={maxCliam}
                                onChange={(event) => {
                                  setMaxCliam(event.target.value);
                                }}
                              />
                            </Form.Group>
                          </div>

                          <div className="col-md-6">
                            <Form.Label> Package Exclude</Form.Label>
                            <FormControl sx={{ width: "100%" }}>
                              <Select
                                labelId="demo-multiple-checkbox-label"
                                id="demo-multiple-checkbox"
                                multiple
                                size="small"
                                value={excludePackage}
                                onChange={handleChange}
                                MenuProps={MenuProps}
                                renderValue={(selected) =>
                                  selected
                                    ?.map(
                                      (id) =>
                                        totalPackage?.find(
                                          (item) => item.id === id
                                        )?.package_name
                                    )
                                    .join(", ")
                                }
                                // renderValue={(selected) =>
                                //   Array.isArray(selected)
                                //     ? selected
                                //         .map((id) => totalPackage.find((item) => item.id === id)?.package_name)
                                //         .join(", ")
                                //     : ""
                                // }

                                style={{ width: "95%" }}
                              >
                                {totalPackage.map((item) => {
                                  if (editData?.id === item.id) {
                                    return null;
                                  } else {
                                    return (
                                      <MenuItem key={item.id} value={item.id}>
                                        <Checkbox
                                          checked={excludePackage.includes(
                                            item.id
                                          )}
                                        />
                                        <ListItemText
                                          primary={item.package_name}
                                        />
                                      </MenuItem>
                                    );
                                  }
                                })}
                              </Select>
                            </FormControl>

                            {/* <Form.Group
                              className="mb-3"
                              controlId="providerName"
                            >
                              <Form.Label>Menu Sort Order</Form.Label>
                        
                              <Form.Select
                                value={menuSort}
                                onChange={(event) => {
                                  setMenuSort(event.target.value);
                                }}
                              >
                                <option value="">Select Menu</option>
                                <option value="Featured 1">Featured 1</option>
                                <option value="Featured 2">Featured 2</option>
                                <option value="Featured 3">Featured 3</option>
                                <option value="Main 1">Main 1</option>
                                <option value="Main 2">Main 2</option>
                                <option value="Main 3">Main 3</option>
                                <option value="Main 4">Main 4</option>
                                <option value="Main 5">Main 5</option>
                               
                              </Form.Select>
                            </Form.Group> */}
                          </div>
                          <div className="col-md-6">
                            <Form.Group
                              className="mb-3"
                              controlId="providerName"
                            >
                              <Form.Label>Limit </Form.Label>
                              <Form.Select
                                value={limit}
                                onChange={(event) =>
                                  setLimit(event.target.value)
                                }
                              >
                                <option value="">Select Limit</option>
                                {[
                                  ...Array.from(
                                    { length: 30 },
                                    (_, index) => index + 1
                                  ),
                                  100,
                                  200,
                                  300,
                                  400,
                                  500,
                                ].map((value) => (
                                  <option key={value} value={value}>
                                    {value}
                                  </option>
                                ))}
                              </Form.Select>
                            </Form.Group>
                          </div>
                          <div className="col-md-6">
                            <Form.Group
                              className="mb-3"
                              controlId="providerName"
                            >
                              <Form.Label>Day </Form.Label>
                              <Form.Select
                                value={day}
                                onChange={(event) => setDay(event.target.value)}
                              >
                                <option value="">Select Days</option>
                                {Array.from({ length: 30 }, (_, index) => (
                                  <option key={index + 1} value={index + 1}>
                                    {index + 1}
                                  </option>
                                ))}
                              </Form.Select>
                            </Form.Group>
                          </div>

                        <div className="col-md-6">
                            <Form.Group
                              className="mb-3"
                              controlId="providerName"
                            >
                              <Form.Label>Play </Form.Label>
                              <Form.Select
                                value={multiplier}
                                onChange={(event) => setMultiplier(event.target.value)}
                              >
                                <option value="">Select Play</option>
                                {Array.from({ length: 10 }, (_, index) => (
                                  <option key={index + 1} value={index + 1}>
                                    {index + 1}x
                                  </option>
                                ))}
                              </Form.Select>
                            </Form.Group>
                          </div>

                          <div className="col-md-6">
                            <Form.Group
                              className="mb-3"
                              controlId="providerName"
                            >
                              <Form.Label>Daily Bouns Coin</Form.Label>
                              <Form.Control
                                type="number"
                                placeholder="Daily Transfer Coin"
                                value={dailyBounsAmount}
                                onChange={(event) => {
                                  setDailyBounsAmount(event.target.value);
                                }}
                              />
                            </Form.Group>
                          </div>

                          <div className="col-md-6">
                            <Form.Group
                              className="mb-3"
                              controlId="providerName"
                            >
                              <Form.Label>Bouns Days</Form.Label>
                              <Form.Select
                                value={bounsDays}
                                onChange={(event) =>
                                  setBounsDays(event.target.value)
                                }
                              >
                                <option value="">Select Bouns Days</option>
                                {[
                                  ...Array.from(
                                    { length: 30 },
                                    (_, index) => index + 1
                                  ),
                                  100,
                                  200,
                                  300,
                                  400,
                                  500,
                                ].map((value) => (
                                  <option key={value} value={value}>
                                    {value}
                                  </option>
                                ))}
                              </Form.Select>
                            </Form.Group>
                          </div>

                          <div className="col-md-3">
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    name="dailyBounsEnable"
                                    checked={checkboxes.dailyBounsEnable}
                                    onChange={handleCheckboxChange}
                                  />
                                }
                                label="Daily Bouns"
                              />
                            </FormGroup>
                          </div>

                          <div className="col-md-3">
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    name="isCheckedActive"
                                    checked={checkboxes.isCheckedActive}
                                    onChange={handleCheckboxChange}
                                  />
                                }
                                label="Active"
                              />
                            </FormGroup>
                          </div>
                          <div className="col-md-2">
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    name="isSpecial"
                                    checked={checkboxes.isSpecial}
                                    onChange={handleCheckboxChange}
                                  />
                                }
                                label="Special"
                              />
                            </FormGroup>
                          </div>
                          <div className="col-md-2">
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    name="isFeature"
                                    checked={checkboxes.isFeature}
                                    onChange={handleCheckboxChange}
                                  />
                                }
                                label="Featured"
                              />
                            </FormGroup>
                          </div>
                          <div className="col-md-2">
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    name="isPopular"
                                    checked={checkboxes.isPopular}
                                    onChange={handleCheckboxChange}
                                  />
                                }
                                label="Popular"
                              />
                            </FormGroup>
                          </div>

                          <div className="col-md-3">
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    name="freeSpin"
                                    checked={checkboxes.freeSpin}
                                    onChange={handleCheckboxChange}
                                  />
                                }
                                label="Free Spin"
                              />
                            </FormGroup>
                          </div>

                          <div className="col-md-3">
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    name="isBoost"
                                    checked={checkboxes.isBoost}
                                    onChange={handleCheckboxChange}
                                  />
                                }
                                label="Coin Boost"
                              />
                            </FormGroup>
                          </div>

                          <div className="col-md-3">
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    name="dailyStreak"
                                    checked={checkboxes.dailyStreak}
                                    onChange={handleCheckboxChange}
                                  />
                                }
                                label="Daily Streak"
                              />
                            </FormGroup>
                          </div>

                          <div className="col-md-3">
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    name="emailPackage"
                                    checked={checkboxes.emailPackage}
                                    onChange={handleCheckboxChange}
                                  />
                                }
                                label="Email Package"
                              />
                            </FormGroup>
                          </div>

                          {copyUrlVisible && checkboxes.emailPackage && (
                            <div className="col-md-12">
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "10px",
                                  padding: "10px",
                                  backgroundColor: "var(--sk-surface2)",
                                  border: "1px solid var(--sk-border)",
                                  borderRadius: "8px",
                                  marginBottom: "15px",
                                }}
                              >
                                <span
                                  style={{
                                    flex: 1,
                                    wordBreak: "break-all",
                                    fontSize: "13px",
                                    fontFamily: "monospace",
                                    color: "var(--sk-text)",
                                  }}
                                >
                                  {packageUrl}
                                </span>
                                <Button
                                  variant="outlined"
                                  size="small"
                                  onClick={handleCopyUrl}
                                  style={{
                                    minWidth: "auto",
                                    padding: "5px 15px",
                                    backgroundColor: "#04631e",
                                    color: "white",
                                    border: "none",
                                  }}
                                >
                                  <ContentCopyIcon style={{ fontSize: "18px", marginRight: "5px" }} />
                                  Copy URL
                                </Button>
                              </div>
                            </div>
                          )}

                          {checkboxes.isBoost && (
                            <div className="col-md-6">
                              <Form.Group className="mb-3" controlId="boostValue">
                                <Form.Label>Boost Value(%)</Form.Label>
                                <Form.Control
                                  type="number"
                                  placeholder="Enter boost value"
                                  value={boostValue}
                                  onChange={(event) => setBoostValue(event.target.value)}
                                />
                              </Form.Group>
                            </div>
                          )}

                          {checkboxes.freeSpin && (
                            <>
                              <div className="col-md-6">
                                <Form.Group className="mb-3">
                                  <Form.Label>Game</Form.Label>
                                  <Autocomplete
                                    options={filteredGames}
                                    getOptionLabel={(option) => option?.game_name || ""}
                                    value={freeSpinGame || null}
                                    onChange={(e, newValue) => {
                                      setFreeSpinGame(newValue || null);
                                      setFreeSpingameid(newValue ? newValue?.game_id : "");
                                      setFreeSpinGameName(newValue ? newValue?.game_name : "");
                                      setGameSearchTerm(newValue ? newValue.game_name : "");
                                    }}
                                    onInputChange={(e, newInputValue, reason) => {
                                      if (reason === "input") setGameSearchTerm(newInputValue);
                                    }}
                                    inputValue={gameSearchTerm}
                                    loading={loadingGames}
                                    noOptionsText={gameSearchTerm.length < 2 ? "Type 2+ chars" : "No games"}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        placeholder="Search game..."
                                        variant="outlined"
                                        fullWidth
                                        InputProps={{
                                          ...params.InputProps,
                                          startAdornment: (
                                            <InputAdornment position="start">
                                              <SearchIcon />
                                            </InputAdornment>
                                          ),
                                          endAdornment: (
                                            <>
                                              {loadingGames ? (
                                                <CircularProgress color="inherit" size={20} />
                                              ) : null}
                                              {params.InputProps.endAdornment}
                                            </>
                                          ),
                                        }}
                                      />
                                    )}
                                    isOptionEqualToValue={(o, v) => o?.game_id === v?.game_id}
                                  />
                                </Form.Group>
                              </div>

                               <div className="col-md-6">
                                <Form.Group className="mb-3">
                                  <Form.Label>Expiry Date</Form.Label>
                                  <Form.Control type="date" value={freeSpinToDate} onChange={(e) => setFreeSpinToDate(e.target.value)} />
                                </Form.Group>
                              </div>

                          {freeSpinGame && (
                            <> 
                          <div className="col-md-6">
                            <Form.Group
                              className="mb-3"
                              controlId="providerName"
                            >
                              <Form.Label>spin count </Form.Label>
                              <Form.Select
                                value={spincount}
                                onChange={(event) => setSpincount(event.target.value)}
                              >
                                <option value="">Select Count</option>
                                {freeSpinGame?.freeCounts?.map((count) => (
                                  <option key={count} value={count}>
                                    {count}
                                  </option>
                                ))}
                              </Form.Select>
                            </Form.Group>
                          </div>

                           <div className="col-md-6">
                            <Form.Group
                              className="mb-3"
                              controlId="freeSpinValue"
                            >
                              <Form.Label>Free spin value</Form.Label>
                              <Form.Select
                                value={freeSpinValue}
                                onChange={(event) => setFreeSpinValue(event.target.value)}
                              >
                                <option value="">Select free Spin</option>
                                {freeSpinGame?.betSize?.map((betSize) => (
                                  <option key={betSize} value={betSize}>
                                    {betSize}
                                  </option>
                                ))}
                              </Form.Select>
                            </Form.Group>
                          </div>

                          </>)}

                              {/* <div className="col-md-6">
                                <Form.Group className="mb-3">
                                  <Form.Label>From Date</Form.Label>
                                  <Form.Control type="date" value={freeSpinFromDate} onChange={(e) => setFreeSpinFromDate(e.target.value)} />
                                </Form.Group>
                              </div> */}

                            </>
                          )}

                          {checkboxes.isFeature && (
                            <div className="col-md-6">
                              <Form.Group className="mb-3">
                                <Form.Label>Feature Name</Form.Label>
                                <Form.Control type="text" placeholder="Feature Name" value={featureName} onChange={(e) => setFeatureName(e.target.value)} />
                              </Form.Group>
                            </div>
                          )}

                          <div className="col-md-12" style={{ marginTop: "10px" }}>
                            <Form.Label style={{ fontWeight: "bold" }}>
                              Exclude Player Type
                            </Form.Label>
                            <FormControl fullWidth size="small">
                              <Select
                                multiple
                                displayEmpty
                                value={excludePlayerTypes}
                                onChange={(e) =>
                                  setExcludePlayerTypes(
                                    (typeof e.target.value === "string"
                                      ? e.target.value.split(",")
                                      : e.target.value
                                    ).map(Number)
                                  )
                                }
                                input={<OutlinedInput />}
                                renderValue={(selected) => {
                                  if (!selected || selected.length === 0) {
                                    return (
                                      <span style={{ color: "#8990b8" }}>
                                        Select player types to exclude
                                      </span>
                                    );
                                  }
                                  return (
                                    <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                                      {selected.map((id) => {
                                        const p = playerList.find((x) => x.id === id);
                                        return (
                                          <Chip
                                            key={id}
                                            size="small"
                                            label={p ? p.player_type : id}
                                          />
                                        );
                                      })}
                                    </div>
                                  );
                                }}
                                MenuProps={{ PaperProps: { style: { maxHeight: 320 } }, sx: { zIndex: 1600 } }}
                              >
                                {playerList.map((player) => (
                                  <MenuItem key={player.id} value={player.id}>
                                    <Checkbox checked={excludePlayerTypes.includes(player.id)} />
                                    <ListItemText primary={player.player_type} />
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </div>
                        </div>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button
                          onClick={handleOk}
                          style={{
                            background: "#04631e",
                            borderColor: "#04631e",
                          }}
                        >
                          Apply
                        </Button>
                      </Modal.Footer>
                    </Modal>

                    {/* Translations popup — fields are kept in state and saved with Apply on the main form. */}
                    <Modal
                      show={showTranslations}
                      onHide={() => setShowTranslations(false)}
                      size="lg"
                      backdrop="static"
                      keyboard={false}
                    >
                      <Modal.Header closeButton>
                        <Modal.Title style={{ fontSize: "20px" }}>Translations</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <div style={{ fontSize: "12px", color: "#8990B8", marginBottom: "12px" }}>
                          Optional. Languages left blank fall back to the English text above.
                        </div>
                        <div className="row">
                          {/* English edits the base field of the main form. */}
                          <div className="col-md-6">
                            <div
                              style={{
                                border: "1px solid #2A3056",
                                borderRadius: "10px",
                                padding: "12px",
                                marginBottom: "12px",
                              }}
                            >
                              <div style={{ fontWeight: 600, marginBottom: "8px" }}>
                                🇺🇸 English <span style={{ color: "#8990B8", fontWeight: 400 }}>(base)</span>
                              </div>
                              <Form.Group className="mb-1" controlId="package_name-en">
                                <Form.Label>Package Name</Form.Label>
                                <Form.Control
                                  type="text"
                                  value={packageName}
                                  onChange={(e) => setPackageName(e.target.value)}
                                />
                              </Form.Group>
                            </div>
                          </div>
                          {LANGS.map((lang) => (
                            <div className="col-md-6" key={lang.code}>
                              <div
                                style={{
                                  border: "1px solid #2A3056",
                                  borderRadius: "10px",
                                  padding: "12px",
                                  marginBottom: "12px",
                                }}
                              >
                                <div style={{ fontWeight: 600, marginBottom: "8px" }}>
                                  {lang.flag} {lang.name}
                                </div>
                                <Form.Group className="mb-1" controlId={`package_name-${lang.code}`}>
                                  <Form.Label>Package Name</Form.Label>
                                  <Form.Control
                                    type="text"
                                    value={translations[lang.code]?.package_name || ""}
                                    onChange={(e) => setTranslationField(lang.code, "package_name", e.target.value)}
                                  />
                                </Form.Group>
                              </div>
                            </div>
                          ))}
                        </div>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button
                          onClick={() => setShowTranslations(false)}
                          style={{ background: "#04631e", borderColor: "#04631e" }}
                        >
                          Done
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  </>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "end",
                  gap: "10px",
                  marginTop: "20px",
                }}
              >
                <Button
                  variant="outline-secondary"
                  onClick={() => setManualDepositShow(true)}
                >
                  Manual Deposit Config
                </Button>
                <Button
                  variant="primary"
                  style={{ background: "#04631e", borderColor: "#04631e" }}
                  onClick={() => {
                    setShow(true);
                    setEditData({});
                    setCreateData(true);
                  }}
                >
                  Add New Coin Package
                </Button>
              </div>

              <ManualDepositConfigModal
                show={manualDepositShow}
                handleClose={() => setManualDepositShow(false)}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CoinPackage;
